import { Link } from "@tanstack/react-router";

// eslint-disable-next-line no-restricted-syntax -- RepeatList del catálogo define 14px por fila.
const ROW_PADDING = "py-3.5";

export interface RepeatItem {
  id: string;
  name: string;
  /** Veces que se repitió. */
  times: number;
  /** Monto ya formateado ("$3,100.00"). */
  total: string;
}

export interface RepeatListProps {
  items: RepeatItem[];
  timesLabel: (times: number) => string;
  moreLabel: string;
  moreTo?: string;
  emptyLabel: string;
}

/** Vista previa de los tres movimientos que más se repiten, en tarjeta neutra: nombre, veces y monto, con enlace «Ver todo» opcional. */
export function RepeatList({ items, timesLabel, moreLabel, moreTo, emptyLabel }: RepeatListProps) {
  return (
    <div className="rounded-[var(--ds-radius-lg)] bg-[var(--ds-surface-raised)] p-5 text-[var(--ds-ink)] md:p-6">
      {items.length === 0 && <p className="m-0 text-base leading-6 text-[var(--ds-ink-muted)]">{emptyLabel}</p>}
      {items.slice(0, 3).map((item, i) => (
        <div key={item.id} className={`flex items-center justify-between gap-3 ${ROW_PADDING} text-base leading-6 ${i > 0 ? "border-t border-solid border-[var(--ds-line)]" : ""}`}>
          <div className="min-w-0">
            <div className="text-[18px] font-medium leading-6">{item.name}</div>
            <div className="text-sm leading-5 text-[var(--ds-ink-muted)]">{timesLabel(item.times)}</div>
          </div>
          <div className="flex-none whitespace-nowrap text-[18px]">{item.total}</div>
        </div>
      ))}
      {moreTo && (
        <Link
          to={moreTo}
          className="mt-2 inline-flex h-9 items-center rounded-full border-[1.5px] border-solid border-[var(--ds-ink)] px-4 text-sm leading-none text-[var(--ds-ink)] no-underline"
        >
          {moreLabel}
        </Link>
      )}
    </div>
  );
}
